var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy_policy"},[_c('PageNav'),_vm._v(" "),_c('div',{staticClass:"content_box"},[_c('h5',{staticClass:"title"},[_vm._v("隐私政策")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('pre',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14a3715d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/privacyPolicy.vue
// module id = null
// module chunks = 